import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="f-upload"
// Swaps the FUpload label text for the chosen file's name.
export default class extends Controller {
  static targets = ["filename"]

  update(event) {
    const file = event.target.files[0]
    this.filenameTarget.textContent = file ? file.name : this.filenameTarget.dataset.default
  }
}
